import { getBit } from "@ponder-shared/utils/bitOperations";

/**
 * Needs to match MagicLegalityType on the backend.
 */
export enum MagicCardLegality {
    None,
    Commander = 1,
    Modern = 2,
    Standard = 4,
    Pioneer = 8,
    Legacy = 16,
    Vintage = 32,
    Oathbreaker = 64,
    Pauper = 128
}

export function isLegalMagicCommander(mask: number): boolean {
    return getBit(mask, 0) == 1;
}

export function isLegalMagicModern(mask: number): boolean {
    return getBit(mask, 1) == 1;
}

export function isLegalMagicStandard(mask: number): boolean {
    return getBit(mask, 2) == 1;
}

export function isLegalMagicPioneer(mask: number): boolean {
    return getBit(mask, 3) == 1;
}

export function isLegalMagicLegacy(mask: number): boolean {
    return getBit(mask, 4) == 1;
}

export function isLegalMagicVintage(mask: number): boolean {
    return getBit(mask, 5) == 1;
}

export function isLegalMagicOathbreaker(mask: number): boolean {
    return getBit(mask, 6) == 1;
}

export function isLegalMagicPauper(mask: number): boolean {
    return getBit(mask, 7) == 1;
}